module.exports = __webpack_public_path__ + "static/media/font-awesome-alt.1ebe32d9.svg";